package org.example.newportfolio.pages
import org.example.newportfolio.components.widgets.chat.GeminiChatBot

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import org.example.newportfolio.components.layouts.DefaultPageLayout
import org.example.newportfolio.components.sections.about.AboutSection
import org.example.newportfolio.components.sections.contact.ContactSection
import org.example.newportfolio.components.sections.education.EducationSection
import org.example.newportfolio.components.sections.experience.ExperienceSection
import org.example.newportfolio.components.sections.start.StartSection
import org.example.newportfolio.components.sections.works.WorksSection
import org.example.newportfolio.components.sections.products.ProductsSection
import org.example.newportfolio.components.widgets.animations.ScrollAnimator

@Page
@Composable
fun HomePage() {
    DefaultPageLayout(title = "Portfolio") {
        Column(
            modifier = Modifier.fillMaxSize().color(Colors.Black),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            StartSection()
            ProductsSection()
            WorksSection()
            ExperienceSection()
            EducationSection()
            AboutSection()
            ContactSection()
            GeminiChatBot()
        }
        // Single global animation driver: scroll-reveals, cursor blob,
        // scroll progress bar. Renders nothing visible; just wires DOM
        // observers and listeners with lifecycle-safe disposal.
        ScrollAnimator()
    }
}
